import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';

//import clsx from 'clsx';
//import { useDispatch, useSelector } from "react-redux";


interface IProps {
  litResult: any;
  }


  const ExperienceShape = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { litResult } = props;

    const [shapeCommentary, setShapeCommentary] = useState("Analyzing...");


    useEffect(() => {
          if (!!litResult) {
            if (litResult?.shape === 'flat') {
                if (litResult?.score >= 75 ) {
                  setShapeCommentary(`While the event didn't have much variation, the overall Immersion of ${litResult?.score} shows that this was a great experience for people.`);
                } else if (litResult?.score >= 40 && litResult?.score < 75) {
                  setShapeCommentary(`Overall, this event was pretty flat, but your overall score was still ok. People will walk away feeling good, but you may want to think about how you can end an experience like this with something stronger.`);
                } else {
                  setShapeCommentary(`Did you see people yawning? An event this flat, combined with the low Immersion level, is likely putting people to sleep.  You need to look at the content, add some variation, and maybe shuffle things around a bit.`);
                }
            } else if (litResult?.shape === 'up') {
              setShapeCommentary(`There was a nice climb of Immersion over the timeline of the event. You generally ended stronger than the start. People are most likely to remember the strong finish, so great work!`);
            } else if (litResult?.shape === 'down') {
              setShapeCommentary(`While you started the event well, the Immersion dropped by the end. This is probably not what you were hoping to see. Because people remember the end more than the beginning of an event, you are not setting yourself up for success.`);
            } else if (litResult?.shape === 'valley') {
              setShapeCommentary(`We really like to see a valley in an experience like this. It shows a strong start and strong finish -- two places where you really need high Immersion to capture the audience. Is there anything you could do to reduce the depth of the valley?`);
            } else if (litResult?.shape === 'mtn') {
              setShapeCommentary(`The content in the middle of this event was the rockstar. You might consider starting or ending with this content to help capture Immersion from the audience or inspire new behavior by putting it at the end.`);
            } 
          }
      }, [props]);
    

      const goToAnalyze = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };

      const getImageUrl = () => {
        const imageName = "black-" + litResult.shape + ".png";
        return "/assets/images/lit/" + imageName;
      }

    //console.log(`i score immersiondata = ${JSON.stringify(immersionData)}`);


    return (

        <Grid item xs={4} style={{textAlign: 'center'}}>
          <img src={getImageUrl()} className={classes.iconImage} />
            
            <Typography variant="body1" className={classes.sectionTitle}>Experience Shape</Typography>
            <Typography variant="body1" className={classes.bodyText}>{shapeCommentary}</Typography>
            <Link className={classes.actionLink} onClick={goToAnalyze}>
                <Typography variant="body1" className={classes.foo}>See the Detail</Typography>
            </Link>
            
          </Grid>

    )


  }

  export default ExperienceShape;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    iconImage: {
      width: '80px',
      height: '80px',
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));